/**
 * Key for dark theme
 */
export const UI_IS_DARK_THEME_KEY = 'uiIsDarkThemeKey';
